// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TBfF","importantInfo":"styles_importantInfo__1qhCk"};